import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCoupons(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/coupons/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCoupon(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/coupons/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editCoupon(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/coupons", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteCoupon(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/coupons", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   
  }
};
